import * as React from "react";
import { forwardRef, memo } from "react";
const SvgFi = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 1800 1100", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { width: 1800, height: 1100, fill: "#fff" }), /* @__PURE__ */ React.createElement("rect", { width: 1800, height: 300, y: 400, fill: "#003580" }), /* @__PURE__ */ React.createElement("rect", { width: 300, height: 1100, x: 500, fill: "#003580" }));
const ForwardRef = forwardRef(SvgFi);
const Memo = memo(ForwardRef);
export default Memo;
